/**
  * 本地存取token/用户等相关信息
  * 
  * @author qingguipeng
  * @since 2019年8月26日11:17:48
  */
const session = {
  getJson(key) {
    try {
      return JSON.parse(sessionStorage.getItem(key))
    } catch (err) {
      return null
    }
  },
  setJson(key, value) {
    try {
      sessionStorage.setItem(key, JSON.stringify(value))
      return true
    } catch (err) {
      return false
    }
  },
  set(key, value) {
    try {
      sessionStorage.setItem(key, value);
      return true
    } catch (err) {
      return false
    }
  },

  get(key, value) {
    try {
      return sessionStorage.getItem(key, value);
    } catch (err) {
      return false
    }
  },

  del(key) {
    sessionStorage.removeItem(key)
  }
};

export default session
